<template>
  <v-col :cols="12" :sm="12" :md="12">
    <v-alert type="error" v-show="erro">{{ mensagemErro }}</v-alert>

    <DataTable
      v-show="showSkeletonTable == false"
      :classTitle="'EnderecoOrdemServico'"
      :tableTitle="'Endereços'"
      :newRowButtonText="'Novo Endereço'"
      :onUpdateoptions="updateOptions"
      :tableHeader="headers"
      :tableData="enderecoOrdemServico"
      :modalFormComposition="formComposition"
      :onUpdate="update"
      :onInsert="insert"
      :onDelete="deleteItem"
      :onUpdateDataTable="UpdateDataTable"
      :isLoadingRequestDisable="isLoadingRequestDisable"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DataTable from "../components/Datatable.vue";
import store from "@/store/index";
import SkeletonTable from "../components/SkeletonTable";

export default {
  components: {
    DataTable,
    SkeletonTable,
  },
  data: () => ({
    erro: false,
    mensagemErro: "Erro",

    isLoadingRequestDisable: false,
    showSkeletonTable: true,

    // Cabeçalho da DataTable
    headers: [
      {
        text: "ID",
        value: "numeroEnderecoOrdemServico",
      },
      {
        text: "Unidade",
        value: "nomeEndereco",
      },
      {
        text: "Rua",
        value: "descricaoEndereco",
      },
      {
        text: "CEP",
        value: "descricaoCep",
      },
      {
        text: "Estado",
        value: "descricaoEstado",
      },
      {
        text: "Bairro",
        value: "descricaoBairro",
      },
      {
        text: "Número",
        value: "descricaoNumeroIdentificador",
      },
      {
        text: "Responsável",
        value: "nomeResponsavel",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],
    //Form composition
    formComposition: [
      {
        title: "Nome da Unidade", // Titulo da label
        type: "text", // Tipo do Input
        size: 6, // Tamanho da coluna
        modelName: "nomeEndereco",
      },
      {
        title: "Rua",
        type: "text",
        size: 6,
        modelName: "descricaoEndereco",
      },
      {
        title: "CEP",
        type: "text",
        size: 6,
        modelName: "descricaoCep",
      },
      {
        title: "Estado",
        type: "text",
        size: 6,
        modelName: "descricaoEstado",
      },
      {
        title: "Bairro",
        type: "text",
        size: 6,
        modelName: "descricaoBairro",
      },

      {
        title: "Número",
        type: "text",
        size: 6,
        modelName: "descricaoNumeroIdentificador",
      },
      {
        title: "Responsável",
        type: "text",
        size: 6,
        modelName: "nomeResponsavel",
      },
      {
        modelName: "descricaoTela",
      },
    ],
    //Array populado pela função initialize
    enderecoOrdemServico: [],
  }),
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      try {
        var config = {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": store.state.token,
          },
        };
        const response = await axios.get("enderecoOrdemServico", config);
        this.enderecoOrdemServico = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async UpdateDataTable() {
      try {
        var config = {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": store.state.token,
          },
        };
        const response = await axios.get("enderecoOrdemServico", config);
        const listFuncionario = response.data;
        for (let enderecoOrdemServico of listFuncionario) {
          enderecoOrdemServico["numeroindicadorNivelAcesso"] =
            enderecoOrdemServico.indicadorNivelAcesso;
          if (enderecoOrdemServico.descricaoCargo === "testador") {
            enderecoOrdemServico["numerodescricaoCargo"] = 1;
          }
          if (enderecoOrdemServico.descricaoCargo === "dev") {
            enderecoOrdemServico["numerodescricaoCargo"] = 1;
          }
        }
        this.showSkeletonTable = false;
        return listFuncionario;
      } catch (error) {
        console.log(error);
      }
    },
    async updateOptions(modelName) {
      if (modelName === "descricaoCargo") {
        const opotionByModalNameInformed = [
          { value: 1, text: "testador" },
          { value: 2, text: "dev" },
        ];
        return opotionByModalNameInformed;
      }
      if (modelName === "indicadorNivelAcesso") {
        const opotionByModalNameInformed = [
          { value: 1, text: "admin" },
          { value: 2, text: "user" },
        ];
        return opotionByModalNameInformed;
      }
    },
    async insert(reciveItem) {
      try {
        if (reciveItem.numerodescricaoCargo == 1) {
          reciveItem["descricaoCargo"] = "dev";
        }
        if (reciveItem.numerodescricaoCargo == 2) {
          reciveItem["descricaoCargo"] = "testador";
        }
        reciveItem["indicadorNivelAcesso"] =
          reciveItem.numeroindicadorNivelAcesso;
        delete reciveItem.numerodescricaoCargo;
        delete reciveItem.numeroindicadorNivelAcesso;
        var config = {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": store.state.token,
          },
        };

        this.isLoadingRequestDisable = true;
        reciveItem["descricaoTela"] = "enderecoOrdemServico";
        await axios.post("enderecoOrdemServico", reciveItem, config);
      
        this.erro = false;
        this.isLoadingRequestDisable = false;
        return true;
      } catch (error) {
        this.mensagemErro = error.response.data.message;
        this.erro = true;
      }
    },
    async update(reciveItem) {
      try {
        var config = {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": store.state.token,
          },
        };

        this.isLoadingRequestDisable = true;
        reciveItem["descricaoTela"] = "enderecoOrdemServico";
        await axios.put("enderecoOrdemServico", reciveItem, config);
       
        this.erro = false;
        this.isLoadingRequestDisable = false;
        return true;
      } catch (error) {
        this.mensagemErro = error.response.data.message;
        this.erro = true;
      }
    },
    async deleteItem(reciveItem) {
      try {
        var config = {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": store.state.token,
          },
        };

        this.isLoadingRequestDisable = true;
        reciveItem["descricaoTela"] = "enderecoOrdemServico";
        await axios.delete("enderecoOrdemServico", {
          data: reciveItem,
          headers: config.headers,
        });
       
        this.erro = false;
        this.isLoadingRequestDisable = false;
        return true;
      } catch (error) {
        this.mensagemErro = error.response.data.message;
        this.erro = true;
      } finally {
        this.initialize();
      }
    },
  },
};
</script>